import { render, staticRenderFns } from "./NavbarProfessor.vue?vue&type=template&id=757a2752&scoped=true"
import script from "./NavbarProfessor.vue?vue&type=script&lang=js"
export * from "./NavbarProfessor.vue?vue&type=script&lang=js"
import style0 from "./NavbarProfessor.vue?vue&type=style&index=0&id=757a2752&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a2752",
  null
  
)

export default component.exports